import { render, staticRenderFns } from "./wmarker.vue?vue&type=template&id=44ce492f&"
import script from "./wmarker.vue?vue&type=script&lang=js&"
export * from "./wmarker.vue?vue&type=script&lang=js&"
import style0 from "./wmarker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('44ce492f', component.options)
    } else {
      api.reload('44ce492f', component.options)
    }
    module.hot.accept("./wmarker.vue?vue&type=template&id=44ce492f&", function () {
      api.rerender('44ce492f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/emap/KXD_VUE_MAP/src/packages/KXD-map/component/wmarker.vue"
export default component.exports